module.exports = __webpack_public_path__ + "img/icon_top_bargain_pre.59e0a769.png";